import { css } from 'styled-components';

export const listStyles = css`
  margin: 1rem 0;
  padding-left: 0;
  line-height: 1.7rem;
  color: #282E38;
`;
